export const ObjGraphsBarHtml2DCSSStyles = {
  container: { marginTop: '10px', marginBottom: '10px' },
};
